import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-white px-6 py-2 text-sm text-gray-400" }
const _hoisted_2 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-600" }, " Indberetning af forrige uge er kun muligt frem til klokken 10:00 ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-xl font-medium text-secondary pb-4" }
const _hoisted_9 = {
  role: "list",
  class: "divide-y divide-gray-200 border-y border-gray-200 p-0"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center shrink-0" }
const _hoisted_12 = { class: "flex flex-col grow" }
const _hoisted_13 = { class: "text-sm font-medium text-blue-900" }
const _hoisted_14 = { class: "text-base font-medium leading-5 text-gray-800 font-semibold" }
const _hoisted_15 = ["v-if"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)
const _hoisted_17 = {
  key: 1,
  class: "flex w-full gap-x-4 no-underline py-1.5"
}
const _hoisted_18 = { class: "flex items-center shrink-0" }
const _hoisted_19 = { class: "flex flex-col grow" }
const _hoisted_20 = { class: "text-sm font-medium text-blue-900" }
const _hoisted_21 = { class: "text-base font-medium leading-5 text-gray-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8",
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.029 20.4773L14.5631 25.9432C14.2995 26.2068 13.8721 26.2068 13.6085 25.9432L12.971 25.3057C12.7079 25.0425 12.7073 24.616 12.9699 24.3522L17.3017 20L12.9699 15.6478C12.7073 15.384 12.7079 14.9575 12.971 14.6943L13.6085 14.0568C13.8721 13.7932 14.2995 13.7932 14.5631 14.0568L20.029 19.5227C20.2926 19.7863 20.2926 20.2137 20.029 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMonday)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("select", {
            id: "combobox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWeek) = $event)),
            class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium",
            role: "combobox",
            "aria-controls": "options",
            "aria-expanded": "false",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onWeekChange()))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekOptions, (week) => {
              return (_openBlock(), _createElementBlock("option", {
                key: week.value,
                value: week.value
              }, _toDisplayString(week.display), 9, _hoisted_3))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedWeek]
          ]),
          (_ctx.selectedWeek !== _ctx.weekNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("h1", _hoisted_8, " Uge " + _toDisplayString(_ctx.weekNumber), 1)
        ])),
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportWeek.reportWeek, (day) => {
        return (_openBlock(), _createElementBlock("li", {
          key: day.dayNumber,
          class: "m-0 flex items-center p-0 cursor-pointer"
        }, [
          (day.project)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _withModifiers(($event: any) => (_ctx.routeToReport(_ctx.getFullDateForDay(_ctx.year, _ctx.selectedWeek, day.dayNumber))), ["prevent"]),
                class: "flex w-full gap-x-4 no-underline py-1.5"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['w-4 h-4 rounded-full', day.timeSpent ? 'bg-emerald-700' : 'bg-gray-200'])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.weekDays[day.dayNumber - 1]) + " - " + _toDisplayString(day.project ? day.project.projectName + ' - ' + day.project.customerName : 'Fri'), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(day.timeSpent ? `${day.timeSpentWithGap ?? day.timeSpent} timer` : '-'), 1),
                  _createElementVNode("div", {
                    class: "text-base font-medium leading-5 text-gray-800",
                    "v-if": day.remark
                  }, _toDisplayString(day.remark), 9, _hoisted_15)
                ]),
                _hoisted_16
              ], 8, _hoisted_10))
            : _createCommentVNode("", true),
          (!day.project)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['w-4 h-4 rounded-full', day.timeSpent ? 'bg-emerald-700' : 'bg-gray-200'])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.weekDays[day.dayNumber - 1]) + " - " + _toDisplayString('Fri'), 1),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(day.timeSpent ? `${day.timeSpentWithGap ?? day.timeSpent} timer` : '-'), 1)
                ]),
                _hoisted_22
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}